<template>
  <base-nav
    v-model="showMenu"
    type="light"
    :transparent="true"
    menu-classes="justify-content-end"
    class="navbar-horizontal navbar-main navbar-logged-out"
    containerClasses="container-fluid col-lg-10"
    expand="lg"
  >
    <div slot="brand" class="navbar-wrapper">
      <!-- Sidenav toggler -->
      <b-navbar-brand to="/">
        <img src="/img/brand/logo-text-refresh.png" />
      </b-navbar-brand>
    </div>

    <template>
      <div class="navbar-collapse-header">
        <b-row>
          <b-col cols="6" class="collapse-brand">
            <router-link to="/">
              <img src="/img/brand/logo-text-refresh.png" />
            </router-link>
          </b-col>
          <b-col cols="6" class="collapse-close">
            <button
              type="button"
              class="navbar-toggler"
              @click="showMenu = false"
            >
              <span></span>
              <span></span>
            </button>
          </b-col>
        </b-row>
      </div>

      <b-navbar-nav class="align-items-lg-center ml-lg-auto">
        <li class="nav-item ml-lg-4">
          <subscribe-button v-if="isWebsitePremium"></subscribe-button>
        </li>
      </b-navbar-nav>
    </template>
  </base-nav>
</template>

<script>
import { BaseNav } from "@/components";
import { mapState, mapGetters, mapActions } from "vuex";
import SubscribeButton from "@/components/Custom/SubscribeButton";

export default {
  name: "PublicStatusPageNavBar",
  components: {
    BaseNav,
    SubscribeButton
  },
  data: () => ({
    showMenu: false,
    notifyModal: false
  }),
  computed: {
    ...mapGetters("website", ["isWebsitePremium"]),
    ...mapState("website", {
      website: (state) => state.data
    })
  },
  methods: {
    subscribeClicked() {
      console.log("WOW!");
      console.log(this.website);
    },
    preventHide(ev) {
      console.log("PREVENTING HIDE!");
      console.log(ev);
      if (window.innerWidth <= 576) {
        ev.preventDefault();
      }
    },
    closeDropdown() {
      // Close the menu and (by passing true) return focus to the toggle button
      this.$refs.featuredropdown.hide(true);
    }
  },
  created: function () {
    if (localStorage.slack && localStorage.slack === "success") {
      const slackData = JSON.parse(localStorage.slack);
      console.log("GOT SLACK DATA from the navbar ok!!");
      console.log(slackData);

      this.$toasted.show("Successfully subscribed!", {
        type: "success",
        duration: 5000
      });

      localStorage.removeItem("slack");
    }
  }
};
</script>

<style></style>
